interface IProps {
  isPopup: boolean;
  isMobile: boolean;
  isNarrow: boolean;
  maxDesktopVisibleItems: number;
}

export const getPreloaderItemsCount = ({ isPopup, isMobile, isNarrow, maxDesktopVisibleItems }: IProps): number => {
  if (isPopup) return 4;

  if (isMobile) return 4;

  if (isNarrow) return 3;

  return maxDesktopVisibleItems ?? 8;
};
